"use strict";

(function () {
  'use strict';

  angular.module('login-service', []).service('LoginService', LoginService);
  LoginService.$inject = ['$http', '$q', 'AuthService'];

  function LoginService($http, $q, AuthService) {
    this.login = function (data) {
      var deferred = $q.defer();
      $http.post('/login/local', data).then(function (response) {
        if (response.data) {
          AuthService.saveToken(response.data);
          deferred.resolve(response);
        } else {
          deferred.reject('Error logging in. Please try again.');
        }
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
      });
      return deferred.promise;
    };

    this.signup = function (data) {
      var deferred = $q.defer();
      $http.post('/login/signup', data).then(function (response) {
        if (response.data) {
          //AuthService.saveToken(response.data);
          deferred.resolve(response);
        } else {
          deferred.reject('Error signing up. Please try again.');
        }
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
      });
      return deferred.promise;
    };

    this.resendVerification = function (email) {
      var deferred = $q.defer();
      $http.post('/account/verify/resend', {
        email: email
      }).then(function (response) {
        if (response.data) {
          deferred.resolve(response);
        } else {
          deferred.reject('Error resending email verification. Please try again.');
        }
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
      });
      return deferred.promise;
    };

    this.logout = function () {
      var deferred = $q.defer();
      $http.post('/login/logout', {}).then(function (response) {
        deferred.resolve(response);
        AuthService.logout();
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
        AuthService.logout();
      });
      return deferred.promise;
    };

    this.sendResetEmail = function (email) {
      var deferred = $q.defer();
      $http.post('/account/password-reset-email', {
        email: email
      }).then(function (response) {
        if (response.data) {
          deferred.resolve(response.data);
        } else {
          deferred.reject('server_error');
        }
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
      });
      return deferred.promise;
    };

    this.resetPassword = function (data) {
      var deferred = $q.defer();
      $http.post('/account/password-reset', {
        password: data.password,
        password2: data.password2,
        token: data.token
      }).then(function (response) {
        if (response.data) {
          AuthService.saveToken(response.data);
          deferred.resolve('reset_successful');
        } else {
          deferred.reject('server_error');
        }
      }, function (errorResponse) {
        deferred.reject(errorResponse.data);
      });
      return deferred.promise;
    };
  }
})();